import { IApplicationState } from '../types/redux';

export function getWebview(state: IApplicationState) {
  return state.webview;
}
